// extracted by mini-css-extract-plugin
export default {"pitch":"soccer-pitch_pitch__aAebG","overlay":"soccer-pitch_overlay__NwRxJ"};